import { useMemo } from "react";
import { resources } from "@constants/hardcoded-strings";
import { WorkflowReportCompletionRateDataType, WorkflowReportVolumesByAppIdResponse } from "@idw-types/data/reports";
import { WorkflowReportSearchFiltersState } from "@idw-types/state/workflow-report-state";
import { CardContainer } from "../../../common/card-container/card-container";
import { ContentPageBody } from "../../../common/content-page-body/content-page-body";
import { ContentPageHeader } from "../../../common/content-page-header/content-page-header";
import { WorkflowReportVolumesByAppIdChart } from "./workflow-report-volumes-by-app-id-chart/workflow-report-volumes-app-id-chart";
import styles from "./workflow-report-volumes-by-app-id-container.less";
import { completionRatesOverTimeTestData } from "@containers/reports/workflow-report/workflow-report-completion-rates-container/workflow-report-completion-rates-over-time-area-chart/test-data";
import { LoadingIndicator } from "@containers/common/loading-indicator/loading-indicator";

type WorkflowReportVolumesContainerProps = {
    workflowReportVolumesByAppIdResponse: WorkflowReportVolumesByAppIdResponse;
    completionRatesResponse: WorkflowReportCompletionRateDataType;
    searchFilters: WorkflowReportSearchFiltersState;
    isLoading: boolean;
};

export const WorkflowReportVolumesByAppIdContainer = (props: WorkflowReportVolumesContainerProps) => {
    const { workflowReportVolumesByAppIdResponse, completionRatesResponse, searchFilters, isLoading } = props;

    const mergedWorkflowReportVolumesByAppIdResponse = useMemo(() => {
        const mergedResponse: WorkflowReportVolumesByAppIdResponse = {
            apps: {},
            interval: null
        };

        if(workflowReportVolumesByAppIdResponse !== null){
            mergedResponse.interval = workflowReportVolumesByAppIdResponse.interval;
            Object.keys(workflowReportVolumesByAppIdResponse.apps).forEach(app => {
                if (app === "null") {
                    mergedResponse.apps[resources.common.notAvailable] = workflowReportVolumesByAppIdResponse.apps[app];
                } else {
                    mergedResponse.apps[app] = workflowReportVolumesByAppIdResponse.apps[app];
                }
            });
        }
         
        return mergedResponse;
    }, [workflowReportVolumesByAppIdResponse]);

    const { transactionCount, userCount } = useMemo(() => {
        let transactionCount = 0;
        let userCount = 0;

        if (completionRatesResponse) {
            userCount = completionRatesResponse.complete + completionRatesResponse.incomplete;
        }
        if(workflowReportVolumesByAppIdResponse !== null){
            Object.keys(workflowReportVolumesByAppIdResponse.apps).forEach(app => {
                workflowReportVolumesByAppIdResponse.apps[app].forEach(appData => {
                    transactionCount += appData.value;
                });
            });
        }
        

        return { transactionCount, userCount };
    }, [completionRatesResponse, mergedWorkflowReportVolumesByAppIdResponse]);

    return (
        <CardContainer>
            <ContentPageHeader title={resources.pages.workflowReport.sections.volumesByAppID.title} />
            <ContentPageBody isMaxWidth={true}>
                {isLoading && <LoadingIndicator title={resources.common.loadingIndicatorText} />}
                {(!isLoading && completionRatesResponse && completionRatesOverTimeTestData) &&
                    <>
                        <span id="workflow-report-volume-by-appid" dangerouslySetInnerHTML={{ __html: resources.pages.workflowReport.sections.volumesByAppID.description(transactionCount, userCount) }} />
                        {transactionCount > 0 && (
                            <>
                                <div className={styles.graphContainer}>
                                    <div className={styles.workflowReportVolumesLineChartContainer}>
                                        <WorkflowReportVolumesByAppIdChart
                                            workflowReportVolumesByAppIdResponse={mergedWorkflowReportVolumesByAppIdResponse}
                                            searchFilters={searchFilters}
                                        />
                                    </div>

                                </div>
                            </>

                        )}
                    </>
                }

            </ContentPageBody>
        </CardContainer>
    );
};